import { render, staticRenderFns } from "./cascaderRemote.vue?vue&type=template&id=b50d0462"
import script from "./cascaderRemote.vue?vue&type=script&lang=js"
export * from "./cascaderRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports